module.exports = __webpack_public_path__ + "assets/class-search-icon.c1d01ef2.svg";